import { LoadStatus } from '@servicetitan/cp-ui';
import { provide, useDependencies } from '@servicetitan/react-ioc';
import { SchedulerApi } from 'api';
import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { DynamicSchedulerType, SchedulerStore } from '../../stores/scheduler.store';
import { SchedulingProProvider } from './scheduling-pro-provider';
import { SchedulingProWidget } from './scheduling-pro-widget';
import { WebSchedulerProvider } from './web-scheduler-provider';
import { WebSchedulerWidget } from './web-scheduler-widget';

export const SchedulingWrapper = provide({ singletons: [SchedulerApi, SchedulerStore] })(
    observer(() => {
        const [{ loadSchedulerSettings, loadStatus, scheduler }] = useDependencies(SchedulerStore);

        useEffect(() => {
            if (loadStatus === LoadStatus.None && !scheduler) {
                loadSchedulerSettings();
            }
        }, [loadSchedulerSettings, loadStatus, scheduler]);

        if (loadStatus !== LoadStatus.Ok || !scheduler) {
            return null;
        }
        if (scheduler.type === DynamicSchedulerType.None) {
            return null;
        }
        return scheduler.type === DynamicSchedulerType.SchedulingPro
            ? scheduler.id && scheduler.dataApiKey && scheduler.schedulingProEmbedScriptUrl && (
                  <SchedulingProProvider
                      dataApiKey={scheduler.dataApiKey}
                      schedulerId={scheduler.id.toString()}
                      scriptUrl={scheduler.schedulingProEmbedScriptUrl}
                  >
                      <SchedulingProWidget />
                  </SchedulingProProvider>
              )
            : scheduler.publicCode && scheduler.webSchedulerScriptUrl && (
                  <WebSchedulerProvider
                      publicCode={scheduler.publicCode}
                      scriptUrl={scheduler.webSchedulerScriptUrl}
                  >
                      <WebSchedulerWidget />
                  </WebSchedulerProvider>
              );
    })
);
